import apiService from "./apiService";

export const invoiceService = {
    getInvoices: (url, params) => apiService.get(url, params),
    getInvoice: (url) => apiService.get(url),
    addInvoice: (url, data) => apiService.post(url, data),
    updateInvoice: (url, data) => apiService.put(url, data),
    deleteInvoice: (url) => apiService.delete(url),
    getInvoiceDetails: (url) => apiService.get(url),
    completeInvoice: (url, data) => apiService.patch(url, data),
    downloadInvoice: (url, params) => apiService.download(url, params),
    paymentInvoice: (url, data) => apiService.put(url, data),
    getInvoiceItems: (url, params) => apiService.get(url, params),
    getInvoiceItem: (url) => apiService.get(url),
    addInvoiceItem: (url, data) => apiService.post(url, data),
    updateInvoiceItem: (url, data) => apiService.put(url, data),
    deleteInvoiceItem: (url) => apiService.delete(url),
}
